import { render, staticRenderFns } from "./multiselect-desc.vue?vue&type=template&id=53fb395b&"
import script from "./multiselect-desc.vue.ts?vue&type=script&lang=js&"
export * from "./multiselect-desc.vue.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports